/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import * as React from 'react';
import { styled } from '@mui/material/styles';
import { TableRow } from '@mui/material';


const StyledRow = styled(TableRow)(({ theme }) => ({
        
    '&:nth-of-type(n-1)': {
        backgroundColor: theme.palette.action.hover,
        borderLeft: "5px solid " + theme.palette.success.light,

    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
        
    },
}));
const StyledTableRow = ({ children }) => {


    return (
        <StyledRow>{children}</StyledRow>
    )

}

export default StyledTableRow;
